import React from 'react';
import AskUs from './view/AskUs'
import {validateObjectField} from "../../../utils/ValidationUtils";
import {initialState, SENT_FAILURE, SENT_OK} from './AskUsState';
import {validateForm, isFormValid, validationDefinitions} from "./AskUsValidations";
import CompanyResource from '../../../service/CompanyResource'

class AskUsContainer extends React.Component {

    constructor(props) {
        super(props);
        // initialize state from another file, just to make code in one file shorter
        this.state = initialState();
    }

    render() {
        return (
            <AskUs
                state={this.state}
                onAskUsChange={this.handleAskUsChange}
                onValidateAskUsField={this.handleValidateAskUsField}
                onSend={this.handleSend}
                onResend={this.handleResend}
                webFormRef={this.props.webFormRef}
                onHandleGdprCheck={this.handleGdprCheck}
            />
        );
    }

    handleAskUsChange = (newPartialInput) => {
        this.setState(state => ({
            ...state,
            ...newPartialInput
        }));
    };

    handleSend = () => {

        const validatedState = validateForm(this.state);
        this.setState(validatedState);

        console.log(validatedState);

        if (isFormValid(validatedState)) {
            console.log("valid");
            CompanyResource.sendQuestion({
                name: this.state.name.value,
                email: this.state.email.value,
                phone: this.state.phone.value,
                company: this.state.company.value,
                number: this.state.number.value,
                question: this.state.question.value,
            }).then(
                () => {
                    this.setState({
                        ...this.state,
                        sentStatus: SENT_OK,
                    });
                },
                () => {
                    this.setState({
                        ...this.state,
                        sentStatus: SENT_FAILURE,
                    });
                }
            );
        }
    };

    handleResend = () => {
        this.setState({
            ...initialState(),
        });
    };

    handleGdprCheck = () => {
        const newGdprChecked = {
            value: !this.state.gdprChecked.value,
            errors: []
        }
        
        this.setState(state => ({
                ...state,
                gdprChecked: newGdprChecked
            })
        );
    }

    handleValidateAskUsField = (validatedField) => {
        const fieldName = Object.keys(validatedField)[0];
        const fieldValue = validatedField[fieldName];
        this.setState(state => ({
                ...state,
                ...validateObjectField(validationDefinitions, fieldName, fieldValue, this.state),
            })
        );
    };
}

export default AskUsContainer;




// WEBPACK FOOTER //
// ./src/components/company/askus/AskUsContainer.jsx